import React from "react";

const Kotlin_Intro = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin Intro</h1>
      <p>Content for Kotlin Intro goes here.</p>
    </div>
  );
};

export default Kotlin_Intro;
